import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';
import { useGenerateReportingEventNumber } from '../common/hooks/use-generate-reporting-event-number';

export function GenerateReportingEventNumberItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: EventContextMenuClickParams;
}): React.ReactElement {
    const [generateReportingEventNumber] = useGenerateReportingEventNumber();

    const { eventNumber, numberOfReportingEventNumbersForPrimaryAgency } = clickParams;

    const handleSelect = (): void => {
        generateReportingEventNumber({
            agencyEventId: clickParams.eventId,
            agencyEventNumber: eventNumber,
            numberOfRensForPrimaryAgency: numberOfReportingEventNumbersForPrimaryAgency,
        });
    };

    return (
        <ContextMenuItem
            dataTrackId="menu-item-generate-reporting-event-number"
            contextMenuItemView={contextMenuItemView}
            onSelect={handleSelect}
        />
    );
}
